import React, { Component } from 'react';
import { connect } from "react-redux";
import LeftSidebar from "./LeftSidebar";
import ChatCenter from "./ChatCenter";
import { useParams } from 'react-router-dom';
import {helperFunctions} from "../../lib/helperFunctions";
import {userBan,closeChat,stopSuperViseChat} from "../../actions/actions";
import Swal from 'sweetalert2';

@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})

class ChatList extends Component {

    constructor(props) {
        super(props);
           this.state={
               "readyChat":false
           }
        this.closeChat=this.closeChat.bind(this);
        this.userBan=this.userBan.bind(this);
        this.closeSupervised=this.closeSupervised.bind(this);
        this.closed_chat=this.closed_chat.bind(this);
        helperFunctions.eventEmitter.addListener('closed_chat', (e) => this.closed_chat(e));

    }
    closeSupervised(e,id,close){
        Swal.fire({
            showCancelButton: true,
            confirmButtonText: close===0 ? 'Stop supervising' : 'Remove Chat',
            reverseButtons: true
        }).then((result) => {
            if (result.isConfirmed) {
                if(close===0){
                    this.props.dispatch(stopSuperViseChat(id));
                } else{
                    this.props.dispatch({
                        type: "DELETE_ACTIVE_CHAT",
                        data: {id: id, filter_key: "id"}
                    });
                }

            }
        });
        e.preventDefault();
    }
    closeChat(e,id,close){
		
		if(close===0){

        Swal.fire({
            showCancelButton: true,
            confirmButtonText: 'Close Chat',
            reverseButtons: true
        }).then((result) => {  
            if (result.isConfirmed) {
                this.props.dispatch(closeChat({id:id}));
            }
        });
		
		}else{
			this.props.dispatch(closeChat({id:id}));
		}
        e.preventDefault();
    }
    closed_chat(){
        console.log("closed_chat");
    }
	
	userBan(e,id){
        Swal.fire({
            showCancelButton: true,
            confirmButtonText: 'Ban User?',
            reverseButtons: true
        }).then((result) => {
            if (result.isConfirmed) {
                this.props.dispatch(userBan({id:id}));
				this.props.dispatch(closeChat({id:id}));
            }
        });
        e.preventDefault();
    }



    componentWillUnmount() {
        this.props.match.params.id=undefined;
    }


    async componentDidMount() {

        this.props.dispatch({
            type: 'SET_MENU',
            data: "chat"
        });

      this.setState({
          "readyChat": true
      });

    }

    render() {

        if(!this.state.readyChat){
            return('');
        }
        return (
            <React.Fragment>
                <div id="chat_left_sidebar_id">
                    <LeftSidebar closeChat={this.closeChat} closeSupervised={this.closeSupervised} selected_id={this.props.match.params.id}/>
                </div>
                <div className="chat-center-div">
                    <ChatCenter closeSupervised={this.closeSupervised} closeChat={this.closeChat} userBan={this.userBan} id={this.props.match.params.id} />
                </div>
            </React.Fragment>

        )

    }
}
export function withRouter(Children){
    return(props)=>{

        const match  = {params: useParams()};
        return <Children {...props}  match = {match}/>
    }
}
export default withRouter(ChatList, { withRef: true });
